var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('wangEditor',{staticClass:"wang",attrs:{"isClear":_vm.isClear},on:{"change":_vm.wangEditorChange},model:{value:(_vm.wangEditorDetail),callback:function ($$v) {_vm.wangEditorDetail=$$v},expression:"wangEditorDetail"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }